import React, { useEffect, useRef, useState } from 'react'
import { withRouter, useParams } from 'react-router-dom'
import { connect } from 'react-redux'
import { getUser } from '../../../reducers'
import cloneDeep from 'lodash.clonedeep'
import { Col, Grid, Row } from 'react-flexbox-grid'
import { Button, Divider, DatePicker, Modal, message, Form, Tooltip } from 'antd'
import FormWorkOrder from '../../containers/FormWorkOrder'
import * as Constants from '../../../constants'
import FormReportWorkOrder from '../../containers/FormReportWorkOrder'
import ReportsWorkOrderTable from '../../containers/ReportsWorkOrderTable'
import LoadingPage from '../../components/LoadingPage'
import { CloseOutlined } from '@ant-design/icons'
import './styles.css'
import { useHistory } from 'react-router-dom';
import FormObstaclesWorkOrder from '../../containers/FormObstaclesWorkOrder'
import ObstacleWorkOrderTable from '../../containers/ObstacleWorkOrderTable'
import moment from 'moment'
import { db, firestore, cloudFunctions } from '../../../config/Fire'
import { generateApprovedQuotationPDF } from '../../utils/pdfUtils'


const DetailsWork = props => {
    const formReportWorkOrderRef = useRef(null)
    const formWorkOrderRef = useRef(null)
    const [updatingWorkOrder, setUpdatingWorkOrder] = useState(false)
    const [updatingWorkOrderReports, setUpdatingWorkOrderReports] = useState(false)
    const [detailsWorkOrder, setDetailsWorkOrder] = useState(null)
    const [bidData, setBidData] = useState(null)
    const { workId } = useParams()
    const history = useHistory();
    const [showModal, setShowModal] = useState(false)
    const [obstacleToEdit, setObstacleToEdit] = useState(null)
    const [pageType, setPageType] = useState('data')
    const [employees, setEmployees] = useState({})
    const [clients, setClients] = useState({})
    const [loadingApprovedQuotation, setLoadingApprovedQuotation] = useState(false)

    useEffect(() => {
        if (workId) {
            firestore.collection(Constants.MAIN_NODES.WORK_ORDERS).doc(workId).get().then(doc => {
                if (doc.exists) {
                    const workOrder = doc.data()
                    setDetailsWorkOrder(workOrder)
                    firestore.collection(Constants.MAIN_NODES.BID_ORDERS).doc(workOrder.bidId).get().then(doc => {
                        if (doc.exists) {
                            const bid = doc.data()
                            setBidData(bid)
                        }
                    }).catch(err => {
                        console.log('Error getting bid data: ' + JSON.stringify(err))
                    })
                }
            })
                .catch(err => {
                    console.log(err)
                })
        }
        getData()
    }, [])

    useEffect(() => {
        if (props.workOrderToEdit) {
            setDetailsWorkOrder(props.workOrderToEdit)
        }
    }, [props.workOrderToEdit])

    const getData = () => {
        db.ref(Constants.MAIN_NODES.USERS).once('value')
            .then(usersSnap => {
                const clientsLoaded = {}
                const employeesLoaded = {}
                if (usersSnap.exists()) {
                    usersSnap.forEach(userSnap => {
                        const user = userSnap.val()
                        if (user.userType === Constants.USER_TYPES.CLIENT) {
                            clientsLoaded[user.id] = user
                        }
                        if (user.userType === Constants.USER_TYPES.EMPLOYEE) {
                            employeesLoaded[user.id] = user
                        }
                    })
                }
                setEmployees(employeesLoaded)
                setClients(clientsLoaded)
            })
            .catch(err => {
                console.log('Error getting users: ' + JSON.stringify(err))
            })
        return <LoadingPage />
    }

    const getWorksListRoute = () => {
        if (!detailsWorkOrder) return '/'
        const company = detailsWorkOrder.company
        if (company === 'SD') {
            return `/${Constants.MenuEmployee.WORKS.SD}`
        } else {
            // Arcasa o undefined
            return `/${Constants.MenuEmployee.WORKS.ARCASA}`
        }
    }

    const downloadApprovedQuotation = async () => {
        if (!detailsWorkOrder || !bidData) {
            message.error('No hay datos disponibles para generar la cotización aprobada')
            return
        }
        setLoadingApprovedQuotation(true)
        try {
            const selectedItems = detailsWorkOrder.selectedItems || detailsWorkOrder.items || []
            const quotationObservations = detailsWorkOrder.quotationObservations || ''

            // Construir clientData con los datos completos de los clientes
            const clientDataArray = []
            if (bidData.clients && Array.isArray(bidData.clients)) {
                bidData.clients.forEach(clientId => {
                    const client = clients[clientId]
                    if (client) {
                        clientDataArray.push({
                            name: client.name || '',
                            interlocutor: client.interlocutor || ''
                        })
                    }
                })
            }
            // Crear una copia de bidData con clientData agregado
            const bidDataWithClientData = {
                ...bidData,
                clientData: clientDataArray
            }

            const userEmail = props.user?.email || ''
            const approvedDoc = await generateApprovedQuotationPDF(bidDataWithClientData, detailsWorkOrder, selectedItems, quotationObservations, userEmail)

            const quotationSuffix = bidData && bidData.quotation ? `_${bidData.quotation}` : ''
            const versionSuffix = detailsWorkOrder.version ? `_V${detailsWorkOrder.version}` : ''
            const approvedFileName = `CotizacionAprobada${quotationSuffix}${versionSuffix}.pdf`
            approvedDoc.save(approvedFileName)
        } catch (err) {
            console.log(err)
            message.error('Se produjo un error al generar la cotización aprobada')
        } finally {
            setLoadingApprovedQuotation(false)
        }
    }

    // Función recursiva para eliminar campos undefined
    const removeUndefinedFields = (obj) => {
        if (obj === null || obj === undefined) {
            return null
        }
        if (Array.isArray(obj)) {
            return obj.map(item => removeUndefinedFields(item)).filter(item => item !== undefined)
        }
        if (typeof obj === 'object') {
            const cleaned = {}
            Object.keys(obj).forEach(key => {
                if (obj[key] !== undefined) {
                    const cleanedValue = removeUndefinedFields(obj[key])
                    if (cleanedValue !== undefined) {
                        cleaned[key] = cleanedValue
                    }
                }
            })
            return cleaned
        }
        return obj
    }

    const updateWorkOrder = workOrder => {
        if (workOrder && detailsWorkOrder && detailsWorkOrder.id) {
            setUpdatingWorkOrder(true)
            let workOrderToUpdate = { ...workOrder }
            if (workOrderToUpdate.fileName === undefined) workOrderToUpdate.fileName = 'OT.pdf'

            // Eliminar campos undefined del objeto recursivamente (Firestore no acepta undefined)
            workOrderToUpdate = removeUndefinedFields(workOrderToUpdate)

            firestore.collection(Constants.MAIN_NODES.WORK_ORDERS).doc(workOrderToUpdate.id).update(workOrderToUpdate)
                .then(() => {
                    setUpdatingWorkOrder(false)
                    message.success('¡La orden de trabajo se editó exitósamente!')
                    setDetailsWorkOrder(workOrderToUpdate)
                    // Redirigir a la lista correcta según la empresa de la OT
                    const company = workOrderToUpdate.company || detailsWorkOrder.company
                    if (workId !== undefined) {
                        if (company === 'SD') {
                            history.push(`/${Constants.MenuEmployee.WORKS.SD}`)
                        } else {
                            // Arcasa o undefined
                            history.push(`/${Constants.MenuEmployee.WORKS.ARCASA}`)
                        }
                    } else {
                        props.onBack(true, workOrderToUpdate)
                    }
                })
                .catch(err => {
                    setUpdatingWorkOrder(false)
                    console.log(err)
                    message.error('Se produjo un error al editar la orden de trabajo. Por favor, vuelva a intentarlo')
                })
            const workOrderLabel = getOTLabel(workOrder)
            workOrder['workOrderLabel'] = workOrderLabel
            const data = {
                workOrderID: workOrder.id,
                detailsOT: workOrder,
            }
            if (detailsWorkOrder.invoicedFreePercentaje !== undefined && detailsWorkOrder.invoicedFreePercentaje !== workOrder.invoicedFreePercentaje) {
                data.type = 'OT_CHANGE_VALUE'
                cloudFunctions.sendEmails(data)
            }
        }
    }

    const submitReportWorkOrder = report => {
        if (detailsWorkOrder && detailsWorkOrder.id) {
            // Validar que existan items
            const items = detailsWorkOrder.selectedItems || detailsWorkOrder.items || []
            if (items.length === 0) {
                message.error('Esta orden de trabajo no tiene items seleccionados. No se pueden crear reportes de avance.')
                return
            }

            setUpdatingWorkOrderReports(true)
            const workOrderToUpdate = cloneDeep(detailsWorkOrder)
            if (!workOrderToUpdate.progressReports) {
                workOrderToUpdate.progressReports = []
            }
            workOrderToUpdate.progressReports.push(report)

            // Calcular porcentaje usando items
            let totalAverageItems = 0.0
            if (workOrderToUpdate.percentagesPerItem && workOrderToUpdate.percentagesPerItem.length > 0) {
                workOrderToUpdate.percentagesPerItem.forEach(percentageItem => {
                    if (report.itemId === percentageItem.itemId) {
                        percentageItem.actualPercentage = report.reportCompletionPercentage
                    }
                    totalAverageItems += percentageItem.actualPercentage * percentageItem.percentage
                })
                workOrderToUpdate.completionPercentage = totalAverageItems / 100
            } else {
                // Fallback: si no hay percentagesPerItem, mantener cálculo por área (para compatibilidad)
                let totalAverageAreas = 0.0
                if (workOrderToUpdate.percentagesPerArea) {
                    workOrderToUpdate.percentagesPerArea.forEach(percentageArea => {
                        if (report.area === percentageArea.area) {
                            percentageArea.actualPercentage = report.reportCompletionPercentage
                        }
                        totalAverageAreas += percentageArea.actualPercentage * percentageArea.percentage
                    })
                }
                workOrderToUpdate.completionPercentage = totalAverageAreas / 100
            }
            firestore.collection(Constants.MAIN_NODES.WORK_ORDERS).doc(detailsWorkOrder.id).update(workOrderToUpdate)
                .then(() => {
                    if (workOrderToUpdate.completionPercentage === 100) {
                        const workOrderLabel = getOTLabel(workOrderToUpdate)
                        workOrderToUpdate['workOrderLabel'] = workOrderLabel
                        const data = {
                            workOrderID: workOrderToUpdate.id,
                            detailsOT: workOrderToUpdate,
                        }
                        data.type = 'OT_FINISHED'
                        cloudFunctions.sendEmails(data)
                    }
                    setUpdatingWorkOrderReports(false)
                    message.success('¡La nueva tarea se agregó exitósamente!')
                    setDetailsWorkOrder(workOrderToUpdate)
                    if (formReportWorkOrderRef && formReportWorkOrderRef.current && formReportWorkOrderRef.current.resetReport) {
                        formReportWorkOrderRef.current.resetReport()
                    }
                })
                .catch(err => {
                    setUpdatingWorkOrderReports(false)
                    console.log(err)
                    message.error('Se produjo un error al agregar la tarea. Por favor, vuelva a intentarlo')
                })
        }
    }

    const submitObstacleWorkOrder = obstacle => {
        if (detailsWorkOrder && detailsWorkOrder.id) {
            setUpdatingWorkOrderReports(true)
            const workOrderToUpdate = cloneDeep(detailsWorkOrder)
            if (!workOrderToUpdate.obstacles) {
                workOrderToUpdate.obstacles = []
            }
            obstacle.status = 'pending'
            workOrderToUpdate.obstacles.push(obstacle)
            firestore.collection(Constants.MAIN_NODES.WORK_ORDERS).doc(detailsWorkOrder.id).update(workOrderToUpdate)
                .then(() => {
                    setUpdatingWorkOrderReports(false)
                    message.success('¡Se agregó la traba exitósamente!')
                    setDetailsWorkOrder(workOrderToUpdate)
                    const workOrderLabel = getOTLabel(workOrderToUpdate)
                    workOrderToUpdate['workOrderLabel'] = workOrderLabel
                    const data = {
                        workOrderID: workOrderToUpdate.id,
                        type: 'OT_LOCK_CREATED',
                        detailsOT: workOrderToUpdate,
                    }
                    cloudFunctions.sendEmails(data)
                })
                .catch(err => {
                    setUpdatingWorkOrderReports(false)
                    console.log(err)
                    message.error('Se produjo un error al agregar la tarea. Por favor, vuelva a intentarlo')
                })
        }
    }

    const getOTLabel = (prop) => {
        const company = prop?.company === 'SD' ? 'SYD' : prop?.company === 'Arcasa' ? 'ARC' : 'O/T'
        if (prop.SAT) {
            return `${company} Nº${prop['workOrderNumber']}/${prop['year'].toString().substring(2, 4)} (SAT)`
        } else {
            return `${company} Nº${prop['workOrderNumber']}/${prop['year'].toString().substring(2, 4)}`
        }
    }

    const getReportsFromWorkOrder = () => {
        const reports = []
        if (detailsWorkOrder && detailsWorkOrder.progressReports) {
            detailsWorkOrder.progressReports.forEach((report, index) => {
                const customReport = report
                customReport.position = index
                reports.push(customReport)
            })
        }
        return reports
    }

    const getObstaclesFromWorkOrder = () => {
        const obstacles = []
        if (detailsWorkOrder && detailsWorkOrder.obstacles) {
            detailsWorkOrder.obstacles.forEach((obstacle, index) => {
                const customObstacle = obstacle
                customObstacle.position = index
                obstacles.push(customObstacle)
            })
        }
        return obstacles
    }

    const removeReportWorkOrder = reportIndex => {
        if (detailsWorkOrder && detailsWorkOrder.id) {
            setUpdatingWorkOrderReports(true)
            const workOrderToUpdate = cloneDeep(detailsWorkOrder)
            if (workOrderToUpdate.progressReports && workOrderToUpdate.progressReports.length >= reportIndex) {
                const reportToRemove = workOrderToUpdate.progressReports[reportIndex]
                workOrderToUpdate.progressReports.splice(reportIndex, 1)

                // Calcular porcentaje usando items
                if (workOrderToUpdate.percentagesPerItem && workOrderToUpdate.percentagesPerItem.length > 0) {
                    let lastReportInItem = null
                    workOrderToUpdate.progressReports.forEach(report => {
                        if (report.itemId === reportToRemove.itemId) {
                            lastReportInItem = report
                        }
                    })
                    let totalAverageItems = 0.0
                    workOrderToUpdate.percentagesPerItem.forEach(percentageItem => {
                        if (reportToRemove.itemId === percentageItem.itemId) {
                            if (lastReportInItem) {
                                percentageItem.actualPercentage = lastReportInItem.reportCompletionPercentage
                            } else {
                                percentageItem.actualPercentage = 0
                            }
                        }
                        totalAverageItems += percentageItem.actualPercentage * percentageItem.percentage
                    })
                    workOrderToUpdate.completionPercentage = totalAverageItems / 100
                } else {
                    // Fallback: si no hay percentagesPerItem, mantener cálculo por área (para compatibilidad)
                    let lastReportInArea = null
                    workOrderToUpdate.progressReports.forEach(report => {
                        if (report.area === reportToRemove.area) {
                            lastReportInArea = report
                        }
                    })
                    let totalAverageAreas = 0.0
                    if (workOrderToUpdate.percentagesPerArea) {
                        workOrderToUpdate.percentagesPerArea.forEach(percentageArea => {
                            if (reportToRemove.area === percentageArea.area) {
                                if (lastReportInArea) {
                                    percentageArea.actualPercentage = lastReportInArea.reportCompletionPercentage
                                } else {
                                    percentageArea.actualPercentage = 0
                                }
                            }
                            totalAverageAreas += percentageArea.actualPercentage * percentageArea.percentage
                        })
                    }
                    workOrderToUpdate.completionPercentage = totalAverageAreas / 100
                }
                firestore.collection(Constants.MAIN_NODES.WORK_ORDERS).doc(detailsWorkOrder.id).update(workOrderToUpdate)
                    .then(() => {
                        setUpdatingWorkOrderReports(false)
                        message.success('¡La nueva tarea se borró exitósamente!')
                        if (props.onUpdateWorkOrder) {
                            props.onUpdateWorkOrder(workOrderToUpdate)
                        }
                        setDetailsWorkOrder(workOrderToUpdate)
                        if (formWorkOrderRef && formWorkOrderRef.current && formWorkOrderRef.current.resetCompletionPercentage) {
                            formWorkOrderRef.current.resetCompletionPercentage()
                        }
                        if (formReportWorkOrderRef && formReportWorkOrderRef.current && formReportWorkOrderRef.current.resetReport) {
                            formReportWorkOrderRef.current.resetReport()
                        }
                    })
                    .catch(err => {
                        setUpdatingWorkOrderReports(false)
                        console.log(err)
                        message.error('Se produjo un error al agregar la tarea. Por favor, vuelva a intentarlo')
                    })
            }
        }
    }

    const removeObstacleWorkOrder = obstacle => {
        if (detailsWorkOrder && detailsWorkOrder.id) {
            setUpdatingWorkOrderReports(true)
            const workOrderToUpdate = cloneDeep(detailsWorkOrder)
            if (workOrderToUpdate.obstacles && workOrderToUpdate.obstacles.length > 0) {
                const obstacleIndex = workOrderToUpdate.obstacles.findIndex(obstacleItem => obstacleItem.number === obstacle.number)
                if (obstacleIndex !== -1) {
                    workOrderToUpdate.obstacles.splice(obstacleIndex, 1)
                    firestore.collection(Constants.MAIN_NODES.WORK_ORDERS).doc(detailsWorkOrder.id).update(workOrderToUpdate)
                        .then(() => {
                            setUpdatingWorkOrderReports(false)
                            message.success('¡La traba se borró exitósamente!')
                            setDetailsWorkOrder(workOrderToUpdate)
                            window.location.reload()
                        })
                        .catch(err => {
                            setUpdatingWorkOrderReports(false)
                            console.log(err)
                            message.error('Se produjo un error al agregar la tarea. Por favor, vuelva a intentarlo')
                        })
                }
            }
        }
    }

    const openShowModal = prop => {
        setObstacleToEdit(prop)
        setShowModal(true)
    }

    const editObstacleWorkOrder = prop => {
        if (detailsWorkOrder && detailsWorkOrder.id) {
            setUpdatingWorkOrderReports(true)
            const workOrderToUpdate = cloneDeep(detailsWorkOrder)
            if (workOrderToUpdate.obstacles && workOrderToUpdate.obstacles.length > 0) {
                const obstacleIndex = workOrderToUpdate.obstacles.findIndex(obstacleItem => obstacleItem.number === obstacleToEdit.number)
                if (obstacleIndex !== -1) {
                    workOrderToUpdate.obstacles[obstacleIndex].endDate = moment(prop.date).format('DD/MM/YYYY')
                    workOrderToUpdate.obstacles[obstacleIndex].status = 'solve'
                    firestore.collection(Constants.MAIN_NODES.WORK_ORDERS).doc(detailsWorkOrder.id).update(workOrderToUpdate)
                        .then(() => {
                            setUpdatingWorkOrderReports(false)
                            message.success('¡La traba se editó exitósamente!')
                            const workOrderLabel = getOTLabel(workOrderToUpdate)
                            workOrderToUpdate['workOrderLabel'] = workOrderLabel
                            const data = {
                                workOrderID: workOrderToUpdate.id,
                                type: 'OT_LOCK_RESOLVED',
                                detailsOT: workOrderToUpdate,
                            }
                            cloudFunctions.sendEmails(data)
                            setDetailsWorkOrder(workOrderToUpdate)
                            setShowModal(false)
                        })
                        .catch(err => {
                            setUpdatingWorkOrderReports(false)
                            console.log(err)
                            message.error('Se produjo un error al agregar la tarea. Por favor, vuelva a intentarlo')
                        })
                }
            }
        }
    }

    const showPage = page => {
        setPageType(page)
    }

    return (
        <Grid className="newWorkCont">
            {
                detailsWorkOrder ?
                    <>
                        <Row center='xs'>
                            {
                                bidData ?
                                    <div className="bidDataBox">
                                        <h3>Información de la Cotización:</h3>
                                        <p><strong>Cotización:</strong> {bidData.quotation}</p>
                                        <p><strong>Fecha de Inicio:</strong> {bidData.startDate}</p>
                                        <p><strong>Empresa:</strong> {bidData.company}</p>
                                        <p><strong>Proyecto:</strong> {bidData.proyect}</p>
                                        <p>
                                            <strong>Ubicación:</strong>{' '}
                                            {bidData.city} - {bidData.province} - {bidData.country || 'Argentina'}
                                        </p>
                                    </div>
                                    : null
                            }
                        </Row>
                        <Row center="xs" style={{ marginTop: 10 }}>
                            {bidData && detailsWorkOrder &&
                                <Button
                                    type="primary"
                                    onClick={downloadApprovedQuotation}
                                    loading={loadingApprovedQuotation}
                                    disabled={loadingApprovedQuotation}
                                >
                                    Descargar cotización aprobada
                                </Button>
                            }
                        </Row>
                        <Row center="xs" className='pageButtons'>
                            <Button onClick={() => showPage('data')} size='large'>Datos</Button>
                            {(() => {
                                const hasItems = (detailsWorkOrder.selectedItems || detailsWorkOrder.items || []).length > 0
                                const trackButton = (
                                    <Button
                                        className='trackButton'
                                        size='large'
                                        onClick={() => showPage('track')}
                                        disabled={!hasItems}
                                    >
                                        Seguimiento
                                    </Button>
                                )
                                return hasItems ? trackButton : (
                                    <Tooltip title="Esta orden de trabajo no tiene items seleccionados. No se pueden crear reportes de avance.">
                                        {trackButton}
                                    </Tooltip>
                                )
                            })()}
                            {detailsWorkOrder.trackingLink && detailsWorkOrder.trackingLink.trim() !== '' && (
                                <Button className='trackButton' size='large' onClick={() => window.open(detailsWorkOrder.trackingLink, '_blank')}>Planner</Button>
                            )}
                        </Row>
                        {
                            pageType === 'data' ?
                                <div>
                                    <Row center="xs">
                                        <Col xs={12}>
                                            <h2>Edición - orden de trabajo</h2>
                                        </Col>
                                    </Row>
                                    <Divider />
                                    <Row center="xs">
                                        <Col xs={12}>
                                            <FormWorkOrder ref={formWorkOrderRef} employees={employees}
                                                clients={clients} isEditing={true}
                                                workOrderToEdit={detailsWorkOrder}
                                                bidData={bidData}
                                                onSubmitWorkOrder={updateWorkOrder}
                                                loading={updatingWorkOrder} />
                                        </Col>
                                    </Row>
                                    <Row center="xs">
                                        <Col xs={6}>
                                            <Button onClick={() => {
                                                workId !== undefined ?
                                                history.push(getWorksListRoute()) :
                                                props.onBack(false)
                                            }} disabled={updatingWorkOrder}
                                                loading={updatingWorkOrder || updatingWorkOrderReports} danger>
                                                <CloseOutlined style={{ color: 'red' }} />Salir
                                            </Button>
                                        </Col>
                                    </Row>
                                </div>
                                :
                                <div>
                                    <Row center="xs">
                                        <Col xs={12}>
                                            <h3>Informe de avances</h3>
                                        </Col>
                                    </Row>
                                    <Divider />
                                    <Row center="xs">
                                        <Col xs={8}>
                                            <FormReportWorkOrder workOrderToEdit={detailsWorkOrder} ref={formReportWorkOrderRef}
                                                loading={updatingWorkOrderReports}
                                                onSubmitReportWorkOrder={submitReportWorkOrder} />
                                        </Col>
                                    </Row>
                                    <Row center="xs">
                                        <Col xs={10}>
                                            <ReportsWorkOrderTable
                                                data={getReportsFromWorkOrder()}
                                                loading={updatingWorkOrderReports}
                                                onRemoveReportWorkOrder={removeReportWorkOrder}
                                                items={detailsWorkOrder.selectedItems || detailsWorkOrder.items || []} />
                                        </Col>
                                    </Row>
                                    {/* Sección de trabas comentada - ya no se cargan más las trabas */}
                                    {/* <Divider/>
                            <Row center="xs">
                                <Col xs={12}>
                                    <h3>Trabas</h3>
                                </Col>
                            </Row>
                            <Row center="xs">
                                <Col xs={8}>
                                    <FormObstaclesWorkOrder workOrderToEdit={detailsWorkOrder} ref={formReportWorkOrderRef}
                                        loading={updatingWorkOrderReports} obstacles={getObstaclesFromWorkOrder()}
                                        onSubmitObstacleWorkOrder={submitObstacleWorkOrder}/>
                                </Col>
                            </Row>
                            <Row center="xs">
                                <Col xs={10}>
                                    <ObstacleWorkOrderTable
                                        data={getObstaclesFromWorkOrder()}
                                        loading={updatingWorkOrderReports} onRemoveObstacleWorkOrder={removeObstacleWorkOrder}
                                        onEditObstacleWorkOrder={openShowModal}/>
                                </Col>
                            </Row>
                            <br/>
                            <Modal title="Editar traba" visible={showModal} onOk={() => {}} onCancel={() => setShowModal(false)} footer={null}>
                                <Form onFinish={editObstacleWorkOrder}>
                                    <Form.Item name="date">
                                        <DatePicker format={'DD/MM/YYYY'} placeholder="Fecha resolución" style={{ width: '100%' }}/>
                                    </Form.Item>
                                    <Row center='xs'>
                                        <Button type="primary" htmlType="submit">Guardar</Button>
                                    </Row>
                                </Form>
                            </Modal> */}
                                    <Row center="xs">
                                        <Col xs={6}>
                                            <Button onClick={() => {
                                                workId !== undefined ?
                                                history.push(getWorksListRoute()) :
                                                props.onBack(false)
                                            }} disabled={updatingWorkOrder}
                                                loading={updatingWorkOrder || updatingWorkOrderReports} danger>
                                                <CloseOutlined style={{ color: 'red' }} />Salir
                                            </Button>
                                        </Col>
                                    </Row>
                                </div>
                        }
                    </>
                    :
                    <LoadingPage />
            }
        </Grid>
    )
}

DetailsWork.propTypes = {}

const mapDispatchToPropsActions = dispatch => ({
})

const mapStateToProps = state => ({
    user: getUser(state)
})

export default withRouter(connect(mapStateToProps, mapDispatchToPropsActions)(DetailsWork))
